import { useContext } from 'react'

import { useQuery } from '@tanstack/react-query'
import { Request } from 'commons/utils/request'
import { CircularProgress } from 'ui/components'
import { Button } from 'ui/components/Buttons'
import { SidePanelContent, SidePanelContext, SidePanelFooter, SidePanelHeader } from 'ui/components/SidePanel'
import { CRBIdLicenseDetails } from '~bank-crb-monitor/types'

import { CRBIdLicenseContext } from './CRBIdLicenseContext'
import { AddressList } from './components/AddressList'
import { Details } from './components/Details'
import { LicensePanel } from './components/LicensePanel'

import { s } from './styles'

export const CRBIdLicensePanel = ({ crbId, onEdit }: { crbId: number; onEdit: () => void }) => {
  const { data, isFetching, isFetched } = useQuery<CRBIdLicenseDetails>({
    queryKey: ['crb-id-license-panel', crbId],
    queryFn: () =>
      Request.post(Request.urls.bank.crbMonitorDetails, {
        id: crbId
      }),
    enabled: crbId > 0
  })

  const context = useContext(SidePanelContext)

  return (
    <>
      <SidePanelHeader>CRB ID License Details</SidePanelHeader>
      <SidePanelContent withoutPadding>
        {isFetching && <CircularProgress centered />}
        {!isFetching && isFetched && data && (
          <CRBIdLicenseContext.Provider value={{ data }}>
            <LicensePanel />
            <Details />
            <AddressList />
          </CRBIdLicenseContext.Provider>
        )}
      </SidePanelContent>
      <SidePanelFooter>
        <s.FooterButtonsWrapper>
          <Button onClick={() => context.close()}>Cancel</Button>
          <Button loading={context.isBlocked} onClick={onEdit} face="primary">
            Edit
          </Button>
        </s.FooterButtonsWrapper>
      </SidePanelFooter>
    </>
  )
}
